import { useEffect, useState } from 'react'
import { Avatar, Card, Input, Separator } from '@design-systems/canvas-ui'

/**
 * Component to show a visual list of sections that are clickable and looks like a connected flow
 * @param {*} props
 * @returns
 */
const SectionGuide = (props) => {
  const [focusStep, setFocusStep] = useState('')

  //#region UseEffects

  useEffect(() => {
    setFocusStep(
      props.focusStep ? props.focusStep : props.steps[0]?.section_name,
    )
  }, [props.focusStep]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (focusStep) {
      props.updateFocusStep(focusStep)
    }
  }, [focusStep]) // eslint-disable-line react-hooks/exhaustive-deps

  //#endregion

  /**
   * Check if step is errored
   * @param {*} stepUid
   * @returns
   */
  const isStepErrored = (stepUid) => {
    return props.errorCache?.section?.includes(stepUid)
  }

  return (
    <Card
      variant="border"
      className="hc8-pv-2x hc8-bg-subdued overflow-x-scroll"
    >
      <div className="hc8-mh-3x align-centre-left" id="step-guide">
        {props.steps.map((eachStep, stepIndex) => {
          return (
            <div
              key={`section-guide-step-${stepIndex}`}
              className="align-centre-left"
              onClick={() => setFocusStep(eachStep.section_name)}
            >
              <div
                className="cursor-pointer align-centre-left"
                data-testid={`step-${stepIndex}`}
              >
                <Avatar
                  aria-label={`${stepIndex + 1}`}
                  color={
                    isStepErrored(eachStep.uid)
                      ? 'red'
                      : eachStep.section_name === focusStep
                        ? 'blue'
                        : 'default'
                  }
                >
                  {stepIndex + 1}
                </Avatar>
                <Input.Label className="hc8-ma-none hc8-pl-2x text-grey hc8-fs-050 cursor-pointer">
                  {eachStep.section_name}
                </Input.Label>
              </div>

              {stepIndex !== props.steps.length - 1 && (
                <Separator className="width-25p hc8-mh-2x" />
              )}
            </div>
          )
        })}
      </div>
    </Card>
  )
}

export default SectionGuide
